export class TireConstant {

    /** タイヤ幅のリスト */
    static readonly WIDTH_LIST: Array<any> = [
        {name: "", value: ""},
        {name: "125", value: "125"},
        {name: "135", value: "135"},
        {name: "145", value: "145"},
        {name: "155", value: "155"},
        {name: "165", value: "165"},
        {name: "175", value: "175"},
        {name: "185", value: "185"},
        {name: "195", value: "195"},
        {name: "205", value: "205"},
        {name: "215", value: "215"},
        {name: "225", value: "225"},
        {name: "235", value: "235"},
        {name: "245", value: "245"},
        {name: "255", value: "255"},
        {name: "265", value: "265"},
        {name: "275", value: "275"},
        {name: "285", value: "285"},
        {name: "295", value: "295"},
        {name: "305", value: "305"},
        {name: "315", value: "315"},
        {name: "325", value: "325"},
        {name: "335", value: "335"},
        {name: "345", value: "345"},
        {name: "355", value: "355"},
        {name: "365", value: "365"},
        {name: "375", value: "375"},
    ];

    /** 扁平率のリスト */
    static readonly ASPECT_RATIO_LIST: Array<any> = [
        {name: "", value: ""},
        {name: "20", value: "20"},
        {name: "25", value: "25"},
        {name: "30", value: "30"},
        {name: "35", value: "35"},
        {name: "40", value: "40"},
        {name: "45", value: "45"},
        {name: "50", value: "50"},
        {name: "55", value: "55"},
        {name: "60", value: "60"},
        {name: "65", value: "65"},
        {name: "70", value: "70"},
        {name: "75", value: "75"},
        {name: "80", value: "80"},
        {name: "82", value: "82"},
        {name: "85", value: "85"},
    ];

    /** リム径のリスト */
    static readonly RIM_DIAMETER_LIST: Array<any> = [
        {name: "", value: ""},
        {name: "12", value: "12"},
        {name: "13", value: "13"},
        {name: "14", value: "14"},
        {name: "15", value: "15"},
        {name: "16", value: "16"},
        {name: "17", value: "17"},
        {name: "18", value: "18"},
        {name: "19", value: "19"},
        {name: "20", value: "20"},
        {name: "21", value: "21"},
        {name: "22", value: "22"},
        {name: "23", value: "23"},
        {name: "24", value: "24"},
        {name: "25", value: "25"},
    ];

    /** エクストラロードのリスト */
    static readonly XL_LIST: Array<any> = [
        {name: "", value: false},
        {name: "XL", value: true},
    ];

    /** ランフラットタイヤのリスト */
    static readonly RFT_LIST: Array<any> = [
        {name: "", value: false},
        {name: "RFT", value: true},
    ];
}